import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Button, Typography } from 'antd';

import type { IContentDelivery } from 'v2/interfaces/product';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import productService from 'v2/services/product';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import GetCcbTerm from './CcbTerm/getCcbTerm';
import { ChangePaymentMethod } from './changePaymentMethod';
import InvoiceDetails from './invoiceDetails';
import { PaymentHistory } from './paymentHistory';
import ProducerContact from './producerContact';
import RefundActions from './refundActions';
import RefundStatus from './refundStatus';

interface InfoProps {
  delivery: ShoppingDelivery;
  closeQuickView: () => void;
}

const Info = ({ delivery, closeQuickView }: InfoProps) => {
  const [contentDelivery, setContentDelivery] = React.useState<IContentDelivery>({
    delivery_nutror: false,
    download_hash: false
  });

  useEffect(() => {
    const fetchContentDelivery = async () => {
      setContentDelivery(await productService.getContentDelivery(delivery.product.id));
    };

    fetchContentDelivery();
  }, [delivery.product.id]);

  const handleClickAccessContent = useCallback(() => {
    window.open('https://app.nutror.com');
  }, []);

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-start gap-3'>
        <img
          className='size-16 shrink-0 rounded bg-(--uizz-antd-color-fill-tertiary) object-cover'
          src={delivery.product.image}
          alt={delivery.product.title}
        />

        <div className='flex min-w-0 flex-col gap-2'>
          <Typography.Text className='block'>{delivery.product.title}</Typography.Text>
          {!delivery?.producer.showProducerContactInformation && (
            <div>
              <Typography.Text className='block'>Produtor:</Typography.Text>
              <Typography.Text type='secondary' className='block'>
                {delivery.producer.name}
              </Typography.Text>
              <Typography.Text type='secondary' className='block'>
                {delivery.producer.email}
              </Typography.Text>
            </div>
          )}
        </div>
      </div>

      <BuyerDetails delivery={delivery} />

      <div>
        {!delivery.unlimited_installment && !delivery?.bankslip_installments && <InvoiceDetails delivery={delivery} />}

        {!delivery.unlimited_installment && delivery?.bankslip_installments && (
          <BankSlipInstallment delivery={delivery} />
        )}

        {delivery.unlimited_installment && <PaymentHistory delivery={delivery} />}
      </div>

      {delivery?.producer.showProducerContactInformation && <ProducerContact delivery={delivery} />}

      <div className='flex flex-col gap-3'>
        {contentDelivery.delivery_nutror && (
          <Button color='default' variant='filled' onClick={handleClickAccessContent} block>
            Acessar conteúdo
          </Button>
        )}
        {delivery.unlimited_installment && <ChangePaymentMethod delivery={delivery} closeQuickView={closeQuickView} />}
        <RefundActions delivery={delivery} />
        {contentDelivery.download_hash && (
          <Link className='text-center' to={`/downloads/${contentDelivery.download_hash}`} target='_blank'>
            Download Materiais
          </Link>
        )}
        <GetCcbTerm delivery={delivery} />
      </div>

      <RefundStatus delivery={delivery} />
    </div>
  );
};

export default Info;
